exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mainContainer {\n  display: flex;\n  justify-content: space-between; }\n\n.leftContainer {\n  display: inline-block;\n  min-width: 400px; }\n\n.rightContainer {\n  display: inline-block;\n  min-width: 400px; }\n\n.devOps {\n  width: 100%;\n  text-align: right; }\n\n.settingsDiv {\n  display: flex;\n  justify-content: space-between; }\n\n.settingsGroup {\n  margin-top: 20px; }\n\n.fieldset {\n  border-radius: 4px;\n  margin-bottom: 30px;\n  border: 1px solid lightgray; }\n  .fieldset legend {\n    margin-bottom: 10px;\n    font-size: larger;\n    font-weight: bold; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/style/AlgorithmSettings.scss
// module id = 1702
// module chunks = 0